const url = "https://api.dev-admin.vexprotech.com"
// const url = "https://qa-admin.vexprotech.com"


module.exports = url;

